import {
  EMPLOYEES_SCREEN_CONTEXT_INITIAL_STATE,
  IEmployeesScreenContext,
} from '@westondev/tableturn-core';
import React from 'react';

export const EmployeesScreenContext =
  React.createContext<IEmployeesScreenContext>(
    EMPLOYEES_SCREEN_CONTEXT_INITIAL_STATE,
  );
